<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab lazy>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Genel Bilgiler
        </template>
        <product-card />
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="DollarSignIcon" />
          Fiyatlandırma
        </template>
        <prices-card />
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Dokümanlar
        </template>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <documents-card />
          </b-col>
          <b-col
            v-if="userData.secret_files === '1' && controlSecretFiles"
            cols="12"
            md="12"
          >
            <secret-documents-card />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Medya Galeri
        </template>
        <media-card is-view />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs, BTab, BRow, BCol,
} from 'bootstrap-vue'
import ProductCard from '@/views/Products/view/ProductCard.vue'
import PricesCard from '@/views/Products/view/PricesCard.vue'
import DocumentsCard from '@/views/Products/view/DocumentsCard.vue'
import SecretDocumentsCard from '@/views/Products/view/SecretDocumentsCard.vue'
import MediaCard from '@/views/Products/Components/MediaCard.vue'

export default {
  name: 'ProductsItemForm',
  components: {
    MediaCard,
    ProductCard,
    SecretDocumentsCard,
    DocumentsCard,
    PricesCard,
    BTabs,
    BTab,
    BRow,
    BCol,

  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    controlSecretFiles() {
      // userData içindeki packageLimits array'inde subject'i PRODUCTS_SECRET_FILES olan elemanın limit'i 1 ise true, değilse false döndürür
      if (
        this.userData
          && Array.isArray(this.userData.packageLimits)
      ) {
        const found = this.userData.packageLimits.find(
          item => item.subject === 'PRODUCTS_SECRET_FILES',
        )
        return found && found.limit === 1
      }
      return false
    },
  },
}
</script>
